<template>
  <div class="carSelection">
    <van-tabs @click="onClickTabs" v-model="active" class="tabs" :line-width="0" title-active-color="#333333" title-inactive-color="#555555">
      <van-tab v-for="(item, index) in carType" :key="index" :title="item.modelName">
        <div class="model-name-title" slot="title">
          {{item.modelName}}
          <span class="title-num" v-show="item.number && item.number>0">{{item.number}}</span>
        </div>
        <div>
          <!-- 多选 -->
          <div class="nowIndex1" v-if="nowIndex===0">
            <van-checkbox-group v-model="result" >
              <van-checkbox
                shape="square"
                v-for="(item, index) in item.supCarPrices"
                :name="item"
                :key="index"
                class="list"
                :style="result===item ? activeIndex : ''"
                label-position="left"
              >
                <img class="logo" :src="item.image" alt="logo" />
                <span class="title">{{item.supplier}}</span>
                <span class="discount" v-if="item.discountedPrice!==item.price">￥<del>{{item.price}}</del></span>
                <span class="price">一口价<strong>{{item.discountedPrice}}</strong>元</span>
              </van-checkbox>
            </van-checkbox-group>
          </div>
          <div class="nowIndex0" v-else>
            <!-- 单选 -->
            <van-radio-group v-model="radio">
              <van-radio label-position="left"  @click="radioClick(item,index)" :name="item.reservation" shape="square" v-for="(item, index) in item.supCarPrices" :key="index" class="list" :style="radio===item.price ? activeIndex : ''">
                <img class="logo" :src="item.image" alt="logo" />
                <span class="title">{{item.supplier}}</span>
                <span class="price">一口价<strong>{{item.discountedPrice}}</strong>元</span>
                <span class="discount" v-if="item.discountedPrice!==item.price">￥<del>{{item.price}}</del></span>
              </van-radio>
            </van-radio-group>
          </div>
          <div class="no-data" v-show="!item.supCarPrices.length">该区域暂无车辆</div>
        </div>
        
      </van-tab>
    </van-tabs>

    <div class="showPayModel" v-if="showServiceModel" @click="serviceModel()"></div>
    <div class="selection-service" @click="service()">车站举牌、预约停车、咨询服务 <img src="../../../assets/new/right.png" alt="right" /></div>
    <transition name="pull-up">
      <selectService v-if="showServiceModel"></selectService>
    </transition>
    <div class="selection-time" v-if="nowIndex===1">
      <span @click="selectionTime()">{{selectDate}}&nbsp;出发</span>
      <img src="../../../assets/new/right.png" alt="right" />
    </div>
    <div class="selection-time" v-else>
      <span>现在</span>出发
    </div>

    <div class="singleBtn" v-if="nowIndex===1">
      <div class="right-off" @click="singleElection()" v-if="Object.keys(this.selectionCarType).length !== 0 && this.selectionActive==this.isHavaActive">立即叫车</div>
      <div class="right-off" style="backgroundColor:#C8C8C8;" v-else>立即叫车</div>
    </div>
    <div class="multipleBtn" v-else>
      <div class="right-off" @click="multipleSelection()" v-if="this.result.length !== 0">
        {{callCar}}
      </div>
      <div class="right-off" style="backgroundColor:#C8C8C8;" v-else>立即叫车</div>
    </div>
    <van-overlay :show="show">
      <div style="display: flex;
                  align-items: center;
                  justify-content: center;
                  height: 100vh;">
        <div class="block">
          <div class="title">同时叫车</div>
          <div class="words">同时叫车按本单各车型需求中费用最高的额度收取预付款，派车成功预付款大于实际用车费用，系统自动退还差价。</div>
          <div class="Iknow"><span @click="Iknow()">我知道了</span></div>
        </div>
      </div>
    </van-overlay>
    <div class="showPayModel" v-show="showPayModel" @click="hidePayModel()"></div>
    <transition name="pull-up">
      <div class="go-pay" v-show="showPayModel">
        <header>
          <span @click="hidePayModel()">取消</span>
          <span>支付中心</span>
          <span></span>
        </header>
        <div class="list" @click="goPay()">
          <img class="iconPay" src="../../../assets/new/wechat.png" alt="微信支付">
          <div class='words'>
            <div class="wen">微信支付</div>
            <div class="zi">安全快捷</div>
          </div>
          <img class="imgRight" src="../../../assets/new/right.png" alt="right" />
        </div>
      </div>
    </transition>
    <Loading :show="loadingShow"/>
  </div>
</template>
<script>
  let currentUrl = window.location.href.substr(0, window.location.href.indexOf('#/')+2);
  import Vue from 'vue';
  import {
    __getItem,
    _getobj,
    __getLocalItem,
    __isWeChat
  } from "@/utils/index";
  import { Tab, Tabs, RadioGroup, Radio, Toast,Checkbox, CheckboxGroup, Overlay } from 'vant';
  import selectService from './selectService.vue';
  import Loading from '@/components/base/loading/loading'

  Vue.use(Tab).use(Tabs).use(RadioGroup).use(Radio).use(Toast).use(Checkbox).use(CheckboxGroup).use(Overlay);

  export default {
    name: "carSelection",
    props: {
      carSelectionVisible: {
        type: Boolean,
      }
    },
    data() {
      return {
        loadingShow: false,
        active: 0,
        activeIndex: {
          backgroundColor: '#F8F8F8',
          borderRadius: '4px'
        }, // 默认选中的车型样式
        show: false, // 我知道了的遮罩层
        showPayModel: false,
        showServiceModel: false,
        radio: '1',
        result: [],
        carType: [],
        selectionCarType: {}, // 选中的车型 价格
        scheduleNo: '', // 支付时返回的行程单号
        allData: [], // 所有车辆
        reservationStrArr: [], // 行程码
        selectedCarTypeNumber: [], // 同时呼叫的车型和数量
        buttonText: '',
        singleOrMultiple: null, // 0单个交车, 1多个叫车
        selectionActive: 0, // 选中的是舒适还是商务还是其它的
        isHavaActive: '-1', // 选中的车型
        callCar: '立即叫车'
      }
    },
    watch: {
      carSelectionVisible: {
        handler(newval, old) {
          if(!newval) {
            this.result = [];
            this.active = 0;
            this.selectionCarType = {}
            this.radio = null
          }
        },
      },
      selectDate: {
        handler(newval, old) {
          let departure = JSON.parse(__getItem('addresName'));
          let arrival = JSON.parse(__getItem('backAddresname'));
          if (departure !== null && arrival !== null) {
            this.generatePrice();
            this.result = [];
          }
        },
      },
      // 监听同时叫车
      result: {
        handler(newval, old) {
          console.log(this.result)
          var resultArr = [];
          for (var x of this.result) {
            resultArr.push(x.modelName)
          }
          resultArr=[...new Set(resultArr)];
          if (resultArr.length === 1) {
            this.callCar = `立即叫车`
          } else {
            this.callCar = `同时呼叫：${resultArr.join('+')}`
          }

          const arr = this.watchCarType(newval); // arr为检测同时呼叫的车型和数量
          this.selectedCarTypeNumber = [...arr];
          let strText = '';
          if(arr.length > 1) {
            arr.forEach(item => {
              strText += item.modelName + ','
            })
            this.buttonText = strText.split(',').slice(0,arr.length).join('+');
          }
          let sameArr = []; // sameArr为获取this.carType与arr相同车型的数据
          // 根据检测到的多选车型，赋值并显示相应的数量
          this.carType.forEach(item => {
            arr.forEach(i => {
              if(item.modelName === i.modelName) {
                sameArr.push(item)
                item.number = i.number
              }
            })
          })
          // 解决多选后并取消数量不能归0的情况
          const diff = this.getArrDifference(this.carType, sameArr);
          // 多选后并取消的车型，不存在的车型，数量归为0
          this.carType.forEach(item => {
            diff.forEach(i => {
              if(item.modelName === i.modelName) {
                item.number = 0
              }
            })
          })
        },
      }
    },
    components: {
      selectService,
      Loading
    },
    mounted() {
      
    },
    computed: {
      selectDate () {
				return this.$store.getters.selectDate
      },
      nowIndex() {
        return this.$store.getters.nowIndex
      }
    },
    methods: {
      // 获取两个数组不同的数据
      getArrDifference(arr1, arr2) {
        return arr1.concat(arr2).filter(function(v, i, arr) {
            return arr.indexOf(v) === arr.lastIndexOf(v);
        });
      },
      // 同时叫车-检测同时呼叫的车型和数量
      watchCarType(params) {
        let resultIndex = [];
        let obj = {};
        params.forEach(item => {
          if(!obj[item.modelName]) {
            obj[item.modelName] = true;
            resultIndex.push({
              modelName: item.modelName,
              number: 0
            })
          }
        })
        params.forEach(item => {
          resultIndex.forEach(i => {
            if(item.modelName === i.modelName) {
              i.number += 1
            }
          })
        })
        return resultIndex;
      },
      singleElection() { // 单选
        if (__getItem('nowIndex') !== '0') {
          if (this.selectDate === '选择时间') {
             return Toast('请选择时间')
          } else {
            const time = new Date().getFullYear() + '/' + this.selectDate.split('月').join('/').split('日').join('');
            if (new Date(time).getTime() - new Date().getTime() < 30*60*1000) {
              return Toast("预约用车需提前30分钟下单");
            }
          }
        }
        console.log(this.selectionCarType)
        if (this.allData.length === 0) return Toast('暂无可用车辆');
        if(Object.keys(this.selectionCarType).length === 0) return Toast("请选择乘坐车型");
        this.showPayModel = true;
      },
      multipleSelection() {
        if (__getItem('nowIndex') !== '0') {
          if (this.selectDate === '选择时间') {
             return Toast('请选择时间')
          } else {
            const time = new Date().getFullYear() + '/' + this.selectDate.split('月').join('/').split('日').join('');
            if (new Date(time).getTime() - new Date().getTime() < 30*60*1000) {
              return Toast("预约用车需提前30分钟下单");
            }
          }
        }
        if (this.allData.length === 0) return Toast('暂无可用车辆');
        // 同时呼叫多个车型
        if(this.result.length === 0) return Toast("请选择乘坐车型");
        if (this.result.length === 1) {
          this.showPayModel = true; // 我知道了的弹窗
        } else if (this.result.length > 1) {
          this.show = true; // 我知道了的弹窗
        }
        

        this.singleOrMultiple = this.result.length === 1 ? 0 : 1;
     
        let reservationArr = []
        this.result.forEach(item => {
          reservationArr.push(item.reservation);
        })

        this.reservationStrArr = [...reservationArr];
        if(reservationArr.length === 1) {
          // 叫一个车
          this.showPayModel = true;
        } else {
          // 叫多个车
          console.log("this.reservationStrArr", this.reservationStrArr)
        }
      },
      Iknow() {
        this.show = false;
        this.showPayModel = true;
      },
      goPay() {
        let addresName = __getItem('addresName')? JSON.parse(__getItem('addresName')): '';
        let backAddresname = __getItem('backAddresname')?JSON.parse(__getItem('backAddresname')): '';
        let currentUseCarUser = __getLocalItem('currentUseCarUser') ? JSON.parse(__getLocalItem('currentUseCarUser')) : '';
        let name = currentUseCarUser.name || '';
        let phone = currentUseCarUser.phone || '';
        if (name === '') return Toast("请填写乘车人姓名");
        if (phone === '') return Toast("请填写乘车人手机号");
        const paramsObj = {
          type: "1",
          reservation: this.$store.state.nowIndex === 0 ? this.reservationStrArr.join():this.selectionCarType.reservation, // 同时叫车多个订单号
          dep: addresName.name,
          arr: backAddresname.name,
          depAddress: addresName.depAddress, // 出发地详细地址
          arrAddress: backAddresname.arrAddress, // 目的地详细地址
          passengerName: name,
          passengerPhone: phone,
          slat: addresName.lat,
          slng: addresName.lng,
          elat: backAddresname.lat,
          elng: backAddresname.lng,
          time: __getItem('nowIndex') === '0' ? new Date() : __getItem('selectedTime'),
          uct: __getItem('nowIndex') === '0' ? 14 : 13,
          openId: __getLocalItem("openId")
        }
        console.log('入参===', paramsObj)
        // 小程序支付，微信环境公众号支付，其他环境微信h5支付
        // payType参数，1微信公众号支付，2微信h5支付，4小程序支付

        if(window.__wxjs_environment === 'miniprogram') return this.miniProgramPay(paramsObj);
        if(__isWeChat()) return this.weixinPay(paramsObj);
        return this.weixinH5Pay(paramsObj);

      },
      // 小程序环境支付
      miniProgramPay(paramsObj) {
        const that = this;
        that.$axios
          .post("/charge/payment", {
            payType: "4",
            ...paramsObj
          })
          .then(response => {
            if (response.data.code === 200) {
              if (response.data.data.payAble) {
                let payParm = JSON.parse(response.data.data.payParm);
                let payParmPackage = payParm.package.split('=')[1];
                const pathUrl = `../wePay/wePay?timeStamp=${payParm.timeStamp}&nonceStr=${payParm.nonceStr}&package=${payParmPackage}&signType=${payParm.signType}&paySign=${payParm.paySign}&tno=${response.data.data.tno}`;
                wx.miniProgram.navigateTo({
                  url: pathUrl
                });
                this.scheduleNo = response.data.data.tno;
              } else {
                Toast("支付信息获取失败，请稍后重试");
              }
            } else if (response.data.code === 4009) {
              Toast("请设置用户名");
              that.$router.push({ name: "LoginName" });
            } else if (response.data.code === 4008) {
              that.generatePrice();
            }
            else if (response.data.code === 400) {
              Toast(response.data.msg);
            }
          })
          .catch(function(err) {
            console.log(err);
          });
      },
      // 微信公众号环境支付
      weixinPay(paramsObj) {
        const that = this;
        that.$axios
          .post("/charge/payment", {
            payType: "1",
            ...paramsObj
          })
          .then(response => {
            if (response.data.code === 200) {
              if (response.data.data.payAble) {
                let json = JSON.parse(response.data.data.payParm);
                this.scheduleNo = response.data.data.tno;
                if (typeof WeixinJSBridge === "undefined") {
                  if (document.addEventListener) {
                    document.addEventListener(
                      "WeixinJSBridgeReady",
                      that.onBridgeReady(json),
                      false
                    );
                  } else if (document.attachEvent) {
                    document.attachEvent(
                      "WeixinJSBridgeReady",
                      that.onBridgeReady(json)
                    );
                    document.attachEvent(
                      "onWeixinJSBridgeReady",
                      that.onBridgeReady(json)
                    );
                  }
                } else {
                  that.onBridgeReady(json);
                }
              } else {
                Toast("支付信息获取失败，请稍后重试");
              }
            } else if (response.data.code === 4009) {
              Toast("请设置用户名");
              that.$router.push({ name: "LoginName" });
            } else if (response.data.code === 4008) {
              that.generatePrice();
            }
            else if (response.data.code === 400) {
             Toast(response.data.msg);
            }
          })
          .catch(function(err) {
            console.log(err);
          });
      },
      // 唤起微信支付
      onBridgeReady(json) {
        let that = this;
        let addresName = __getItem('addresName')? JSON.parse(__getItem('addresName')): '';
        let backAddresname = __getItem('backAddresname')?JSON.parse(__getItem('backAddresname')): '';

        window.WeixinJSBridge.invoke(
          "getBrandWCPayRequest",
          {
            appId: json.appId, // 公众号名称，由商户传入
            timeStamp: json.timeStamp, // 时间戳，自1970年以来的秒数
            nonceStr: json.nonceStr, // 随机串
            package: json.package,
            signType: json.signType, // 微信签名方式：
            paySign: json.paySign // 微信签名
          },
          function(res) {
            if (res.err_msg === "get_brand_wcpay_request:ok") {
              Toast("支付成功");
              // 使用以上方式判断前端返回,微信团队郑重提示：res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
              let params = {
                lev: that.selectionCarType.supModelName,
                travelTime: __getItem('nowIndex') === '0' ? new Date() : __getItem('selectedTime'),
                price: that.selectionCarType.price,
                dep: addresName.name,
                arr: backAddresname.name,
                depLng: addresName.lng,
                depLat: addresName.lat,
                arrLng: backAddresname.lng,
                arrLat: backAddresname.lat,
                uct: __getItem('nowIndex') === '0' ? 14 : 13,
                tno: that.scheduleNo
              };
              that.$router.push({ path: "orderpay", query: params });
            } else {
              // 失败
              Toast("支付失败, 请稍后重试");
            }
          }
        );
      },
      // 微信H5支付
      weixinH5Pay(paramsObj) {
        const that = this;
        that.$axios
          .post("/charge/payment", {
            payType: "2",
            ...paramsObj
          })
          .then(response => {
            if(response.data.code === 200 && response.data.data) {
              const payParm = response.data.data.payParm ? JSON.parse(response.data.data.payParm) : {};
              if(payParm && payParm.mwebUrl) {
                let url = encodeURIComponent(`${currentUrl}successfulPay?tno=${response.data.data.tno}`);
                window.location.href = payParm.mwebUrl + `&redirect_url=${url}`;
              }
            }
            if(response.data.code === 400){
              return Toast(response.data.msg);
            }
          })
          .catch(function(err) {
            console.log(err);
          });
      },
      hidePayModel() {
        this.showPayModel = false;
      },
      radioClick(item, index) {
        this.isHavaActive = this.selectionActive;
        this.selectionCarType = item;
      },
      onClickTabs(name, title) {
        this.selectionActive = name;
      },
      selectionTime() {
        this.$emit('isLogin', 3);
      },
      service() {
        this.showServiceModel = true;
      },
      serviceModel() {
        this.showServiceModel = false;
      },
      // 生成价格
      generatePrice() {
        this.result = [];
        let city = __getItem('city');
        city = city && city.substr(-1) === '市' ? city.substring(0, city.length - 1) : city;
        let addresName = __getItem('addresName')? JSON.parse(__getItem('addresName')): '';
        let backAddresname = __getItem('backAddresname')?JSON.parse(__getItem('backAddresname')): '';
        let params = {
          slat: addresName.lat,
          slng: addresName.lng,
          elat: backAddresname.lat,
          elng: backAddresname.lng, 
          time: __getItem('nowIndex') === '0' ? new Date() : __getItem('selectedTime'),
          uct: __getItem('nowIndex') === '0' ? 14 : 13,
          cityName: city,
          startAddress: addresName.name,
          endAddress: backAddresname.name
        };
        this.loadingShow = true;
        this.$axios
          .get("/travel/prices?" + _getobj(params))
          .then(res => {
            this.loadingShow = false;
            if (res.data.code === 200 && res.data.data) {
              this.carType = res.data.data;
              for(let value of this.carType.values()) {
                for ( let x of value.supCarPrices.values()) {
                  this.allData.push(x);
                }
              }
            } else {
              Toast(res.data.msg);
              // 解决多选后并取消数量不能归0的情况
              const diff = this.getArrDifference(this.carType, sameArr);
              // 多选后并取消的车型，不存在的车型，数量归为0
              this.carType.forEach(item => {
                diff.forEach(i => {
                  if(item.modelName === i.modelName) {
                    item.number = 0
                  }
                })
              })
            }
          })
          .catch(function(err) {
            console.log(err);
          });
      },
    }
  }
</script>
<style lang="css">
  .van-radio__label {
    display: block;
    text-align: right;
    width: 100%;
    margin: 0;
  }
  .van-tab--active {
    font-size: 18px;
    font-family: PingFang-SC-Bold,PingFang-SC;
    font-weight: bold;
    color: rgba(51,51,51,1);
  }
  .van-checkbox__label {
    width: 90%;
  }
  .van-checkbox__icon {
    position: absolute;
    top: 0;
    bottom: 0;
    right: 3%;
    margin: auto;
  }
  .pull-up-enter-active {
    transition: all 0.3s ease;
  }
  .pull-up-leave-active {
    transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
  }
  .pull-up-leave-to,
  .pull-up-enter {
    transform: translateY(100px);
    opacity: 0;
  }
</style>
<style lang="scss" scoped>
  .carSelection {
    position: fixed;
    left: 0;
    bottom: 0;
    z-index: 222;
    width: 100%;
    background-color: #fff;
    box-shadow: 0px -2px 6px 0px rgba(0,0,0,0.1);
    border-radius: 10px 10px 0px 0px;
    .tabs {
      background-color: #fff;
      box-shadow: 0px -2px 6px 0px rgba(0,0,0,0.1);
      border-radius: 10px 10px 0px 0px;
      overflow: hidden;
      .model-name-title {
        .title-num {
          position: relative;
          top: -2px;
          display: inline-block;
          vertical-align: middle;
          width:16px;
          height:16px;
          font-size: 11px;
          line-height: 16px;
          text-align: center;
          color: #fff;
          border-radius: 50%;
          background:rgba(37,163,255,1);
        }
      }
      .no-data {
        margin: 15px;
        padding: 12px 0 16px 0;
        line-height: 44px;
        border:1px solid #E5E5E5;
        border-radius:4px;
        font-size: 18px;
        font-weight: bold;
        color: #C5C5C5;
      }
      .list {
        margin: 0 10px;
        border-radius: 4px;
        position: relative;
        .logo {
          width: 28px;
          height: 28px;
          margin: 16px 8px;
          float: left;
        }
        .title {
          line-height: 60px;
          font-size:14px;
          font-family:PingFang-SC-Bold,PingFang-SC;
          font-weight:bold;
          color:rgba(51,51,51,1);
          float: left;
        }
        .price {
          line-height: 55px;
          font-size:11px;
          font-family:PingFang-SC-Medium,PingFang-SC;
          font-weight:500;
          color:rgba(51,51,51,1);
          margin-right: 5px;
          float: right;
          strong {
            font-size:22px;
            font-family:DINAlternate-Bold,DINAlternate;
            color:rgba(51,51,51,1);
          }
        }
        .discount {
          line-height: 60px;
          font-size: 12px;
          font-family: PingFang-SC-Medium,PingFang-SC;
          font-weight: 500;
          color: #C9C9C9;
          margin: 0 10px 0 0;
          float: right;
        }
      }
    }
    .selection-service {
      font-size:14px;
      font-family:PingFang-SC-Bold,PingFang-SC;
      font-weight:bold;
      color: #25A3FF;
      margin: 20px 0 10px 0;
      img {
        width: 8px;
        height: 11px;
        margin-left: 5px;
      }
    }
    .selection-time {
      font-size:15px;
      font-family:PingFang-SC-Bold,PingFang-SC;
      font-weight:bold;
      color:rgba(85,85,85,1);
      margin: 10px 0 10px 0;
      img {
        width: 10px;
        height: 13px;
        margin-left: 5px;
      }
    }
    .block {
      width: 80%;
      background:rgba(255,255,255,1);
      border-radius:4px;
      .title {
        color: #333333;
        font-size: 18px;
        font-weight: bold;
        margin: 28px 0 20px 0;
      }
      .words {
        font-size:14px;
        font-family:PingFangSC-Regular,PingFang SC;
        font-weight:400;
        color:rgba(153,153,153,1);
        margin: 0 35px;
        line-height: 20px;
        text-align: left;
        margin-bottom: 20px;
        letter-spacing: 1px;
      }
      .Iknow {
        height: 55px;
        line-height: 55px;
        font-size: 14px;
        border-top: 1px solid #eee;
        span {
          font-size: 14px;
          color: #25A3FF;
          height: 55px;
          display: inline-block;
        }
      }
    }
    .right-off {
      margin: 0 20px 20px 20px;
      height: 50px;
      line-height: 50px;
      text-align: center;
      background-color: #25A3FF;
      border-radius: 4px;
      font-size: 16px;
      font-family:PingFang-SC-Bold,PingFang-SC;
      font-weight:bold;
      color: #fff;
      letter-spacing: 1px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .showPayModel {
      position: fixed;
      top: 0;
      left: 0;
      z-index: 888;
      width: 100%;
      height: 100vh;
      background:rgba(0,0,0,0.5);
    }
    .go-pay {
      position: fixed;
      bottom: 0;
      left: 0;
      z-index: 1000;
      width: 100%;
      background-color: #fff;
      header {
        width: 100%;
        height: 50px;
        line-height: 50px;
        text-align: center;
        display: flex;
        border-bottom: 1px solid rgba(238,238,238,1);
        span {
          display: block;
        }
        span:nth-child(1), span:nth-child(3) {
          width: 15%;
          font-size:14px;
          font-family:PingFang-SC-Medium,PingFang-SC;
          font-weight:500;
          color:rgba(106,106,106,1);
        }
        span:nth-child(2) {
          width: 70%;
          font-size:18px;
          font-family:PingFang-SC-Bold,PingFang-SC;
          font-weight:bold;
          color:rgba(51,51,51,1);
        }
      }
      .list {
        height:60px;
        background:rgba(255,255,255,1);
        box-shadow:0px 1px 1px 0px rgba(51,51,51,0.05);
        display: flex;
        position: relative;

        .iconPay{
          width: 38px;
          height: 38px;
          margin: 9px 15px;
        }
        .words {
          height: 38px;
          margin: 9px 0;
          text-align: left;
          .wen {
            font-family: 'PingFangSC-Regular';
            color: #333333;
            height: 19px;
            font-size:15px;
            font-family:PingFang-SC-Bold,PingFang-SC;
            font-weight:bold;
            line-height:19px;
          }
          .zi {
            font-family: 'PingFangSC-Regular';
            font-size: 12px;
            color: #999999;
            height: 19px;
            line-height: 19px;
          }
        }
        .imgRight {
          width: 10px;
          height: 14px;
          position: absolute;
          top: 23px;
          right: 15px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Home/components/carSelection.vue